import React, { useState } from 'react';
import TextInputField from 'components/TextInputField';
import { Dropdown } from 'components/Dropdown/Dropdown';
import './AdvancedFilters.css';

interface AdvancedFiltersProps {
  filters: {
    artist?: string;
    flavorText?: string;
    lang?: string;
    format?: string;
    formatLegality?: 'legal' | 'not_legal';
  };
  onFilterChange: (key: string, value: any) => void;
  onKeyDown?: (event: React.KeyboardEvent<HTMLInputElement>) => void;
}

export default function AdvancedFilters({ filters, onFilterChange, onKeyDown }: AdvancedFiltersProps) {
  const [formatValue, setFormatValue] = useState(filters.formatLegality === 'not_legal' ? 'Not Legal' : 'Legal');
  const [formatScope, setFormatScope] = useState(filters.format || 'all formats');
  const [priceType, setPriceType] = useState('Less than');
  const [language, setLanguage] = useState(filters.lang || 'Default');

  const handleFormatValueChange = (value: string) => {
    setFormatValue(value);
    onFilterChange('formatLegality', value === 'Legal' ? 'legal' : 'not_legal');
  };

  const handleFormatScopeChange = (value: string) => {
    setFormatScope(value);
    onFilterChange('format', value === 'all formats' ? undefined : value);
  };

  const handleLanguageChange = (value: string) => {
    setLanguage(value);
    onFilterChange('lang', value === 'Default' ? undefined : value.toLowerCase());
  };

  return (
    <div className="advanced-filters">
      <div className="filter-block">
        <label>Formats</label>
        <div className="format-controls">
          <Dropdown
            options={['Legal', 'Not Legal']}
            value={formatValue}
            onChange={handleFormatValueChange}
          />
          <Dropdown
            options={['all formats', 'Alchemy', 'Brawl', 'Commander', 'Historic', 'Legacy', 'Modern', 'Oathbreaker', 'Pauper', 'Penny', 'Pioneer', 'Premodern', 'Standard', 'Timeless', 'Vintage']}
            value={formatScope}
            onChange={handleFormatScopeChange}
          />
        </div>
      </div>

      <div className="filter-block">
        <label>Price</label>
        <div className="price-controls">
          <Dropdown
            options={['Less than', 'Greater than', 'Equal to']}
            value={priceType}
            onChange={setPriceType}
          />
          <TextInputField placeholder="Point value" onChange={() => {}} />
        </div>
      </div>

      <div className="filter-block">
        <label>Artist</label>
        <TextInputField 
          placeholder='Artist name, e.g. "Rebecca Guay"' 
          value={filters.artist || ''}
          onChange={(value) => onFilterChange('artist', value)}
          onKeyDown={onKeyDown}
        />
      </div>

      <div className="filter-block">
        <label>Flavor Text</label>
        <TextInputField 
          placeholder='Any flavor text, e.g. "Serra"' 
          value={filters.flavorText || ''}
          onChange={(value) => onFilterChange('flavorText', value)}
          onKeyDown={onKeyDown}
        />
      </div>

      <div className="filter-block">
        <label>Language</label>
        <Dropdown
          options={['Default', 'English', 'Japanese', 'French', 'German']}
          value={language}
          onChange={handleLanguageChange}
        />
      </div>
    </div>
  );
}
